import React from "react";
import ErrorPage from "src/components/ErrorPage";

const Page500 = () => {
  return <ErrorPage code={500} />;
};

export default Page500;
